module.exports = __webpack_public_path__ + "img/隐私协议.ec5f2cd7.png";